import {contractApi} from "@/axios";

export function getAuditPage(params,data,type){
    return contractApi({
        url:'/audit-info/page' + type,
        method:'post',
        params: params,
        data:data
    })
}

export function auditInfo(data){
    return contractApi({
        url:'/audit-info/audit',
        method:'put',
        data:data
    })
}

export function auditMaterial(data){
    return contractApi({
        url:'/audit-info/material-audit',
        method:'put',
        data:data
    })
}

//下载附件
export function attachmentDownload(id,annexType) {
    return contractApi({
        url: '/audit-info/attachment/' + id + '/' + annexType,
        method: 'get',
        responseType: 'blob', // 设置响应类型为 blob
    });
}
//审核合同发票
export function auditContractInvoice(data){
    return contractApi({
        url:'/sequencing-contract/contract-invoice-audit',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//审核纯分析
export function pureAudit(data){
    return contractApi({
        url:'/audit-info/pureAudit',
        method:'put',
        data:data,
        headers: {
            'Content-Type': 'multipart/form-data' // 指定内容类型为 form-data
        }
    })
}
//修改纯分析评估人
export function revise(params){
    return contractApi({
        url:'/audit-info/revise-pure-audit-person',
        method:'put',
        params:params,
    })
}
//导出
export function exportInfo(data) {
    return contractApi({
        url: '/audit-info/export',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}
//下载项目附件
export function downloadProjectAttachment(auditInfoId, projectMainTypeId) {
    return contractApi({
        url: `/audit-info/project-annex/${auditInfoId}/${projectMainTypeId}`,
        method: 'get',
        responseType: 'blob',
    })
}
